import { createRootRoute, Outlet, redirect } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { useAuthStore } from '@/features/auth/store/auth-store';
import { PUBLIC_PATHS } from '@/lib/routing/constants/public-routes';

export const Route = createRootRoute({
  component: RootComponent,
  beforeLoad: ({ location }) => {
    const isAuthenticated = useAuthStore.getState().isAuthenticated;
    const isPublicPath = PUBLIC_PATHS.includes(location.pathname as (typeof PUBLIC_PATHS)[number]);

    if (!isAuthenticated && !isPublicPath) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login' });
    }

    if (isAuthenticated && isPublicPath) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/' });
    }
  },
});

function RootComponent() {
  return (
    <>
      <Outlet />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  );
}
